import {
  setNewPhoneNo,
  setOauthToken,
  setPhoneNo,
  setUserId
} from 'store/actions/auth';

export const handleSuccessUpdatePhoneNumber = (
  dispatch,
  param,
  auth,
  res,
  action
) => {
  const mobileNo = auth.newPhoneNumber;
  const authPhoneNo = auth?.phoneNo;

  if (!param.isFirst) {
    dispatch(setPhoneNo(mobileNo));
    dispatch(setNewPhoneNo(''));
    dispatch(setOauthToken('', ''));

    if (!localStorage.getItem('phonePrincipal')) {
      setUserId(authPhoneNo);
    }

    param.modal?.();

  }

  localStorage.setItem('requestId', res.data.userDetails.requestId);
  dispatch(setNewPhoneNo(auth.newPhoneNumber));

  action?.success?.(res.data.isFaceCompare);
};
